import { DAILY_PAGES } from '@/components/pages/page-daily-markets-details/page-daily-markets-details.vue';

export default {
  data() {
    return {
      items: [
        { link: DAILY_PAGES.MONDAY.id, title: DAILY_PAGES.MONDAY.title },
        { link: DAILY_PAGES.TUESDAY.id, title: DAILY_PAGES.TUESDAY.title },
        // { link: DAILY_PAGES.WEDNESDAY.id, title: DAILY_PAGES.WEDNESDAY.title },
        // { link: DAILY_PAGES.THURSDAY.id, title: DAILY_PAGES.THURSDAY.title },
      ],
    };
  },
  methods: {
    dailyMarketPageLink(item) {
      return { name: item.link };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/daily-markets/daily-markets.js